import { render } from "./detail.vue?vue&type=template&id=8d6d5136&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts&config=true"
export * from "./detail.vue?vue&type=script&lang=ts&config=true"

import "./detail.vue?vue&type=style&index=0&id=8d6d5136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6d5136"]])

export default __exports__